//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ColumnsSelect from '@/components/ColumnsSelect'
import SearchInput from '@/components/SearchInput'
import CommentsDialog from './components/CommentsDialog'
import IhmApi from '@/api/promotores/ihm.api'

export default {
  components: { ColumnsSelect, SearchInput },
  data() {
    return {
      visible_columns: [
        'id', 'nombre', 'correo', 'celular', 'promotor', 'comentarios', 'status', 'created_at', 'updated_at'
      ],
      columns: [
        { name: 'id', field: '_id', label: 'ID', align: 'left' },
        { name: 'nombre', field: 'nombre', label: 'Nombre', sortable: true, align: 'left' },
				{ name: 'correo', field: 'correo', label: 'Email', align: 'left' },
				{ name: 'celular', field: 'celular', label: 'Celular', align: 'left' },
				{ name: 'promotor', field: 'usuario', label: 'Promotor', sortable: true, align: 'left' },
				{ name: 'desarrollo', field: 'desarrollo', label: 'Desarrollo', sortable: true, align: 'left' },
				{ name: 'comentarios', field: 'comentarios', label: 'Comentarios', align: 'left' },
				{ name: 'status', field: 'status', label: 'Status', sortable: true, align: 'left' },
				{ name: 'created_at', field: 'created_at', label: 'Creado', sortable: true, align: 'left' },
				{ name: 'updated_at', field: 'updated_at', label: 'Actualizado', sortable: true, align: 'left' },
      ],
      prospectos: [],
      status: [
        { value: 'en proceso', label: 'En Proceso' },
        { value: 'autorizado', label: 'Autorizado' },
        { value: 'cancelado', label: 'Cancelado' },
      ],
      loading: false,
      filter: null,
    }
  },

  mounted() {
    this.loadProspectos()
  },

  methods: {
    async loadProspectos() {
      try {
        this.loading = true
        this.prospectos = await IhmApi.all()
      } finally {
        console.log('finally')
        this.loading = false
      }
    },
    async updateStatus(prospecto) {
      try {
        this.loading = true
        await IhmApi.update(prospecto._id, {
          status: prospecto.status
        })
        this.loadProspectos()
      } finally {
        this.loading = false
      }
    },
    async openComentariosDialog({ _id, nombre, email, comentarios}) {
			this.$q.dialog({
				component: CommentsDialog,
				prospecto_id: _id,
				title: `Comentarios para ${nombre}`,
				comentarios,
				organizacion_id: 'ihm',
			})
				.onOk((comentario) => {
					comentarios.push(comentario);
				})
		},
  }
}
